export default __webpack_public_path__ + "static/media/mb-logo.8c059a10.png";